<script lang="ts">
    import type * as Pdfjs from 'pdfjs-dist/types/src/pdf';
    import MvPdfPagePreview from './MvPdfPagePreview.svelte';

    export let pages: Pdfjs.PDFPageProxy[];
</script>

<div class="pages-overview-container">
    {#each pages.toSorted((a, b) => a.pageNumber - b.pageNumber) as page}
        <MvPdfPagePreview {page}/>
    {/each}
</div>

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";

    .pages-overview-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: @spacing-m;
    }
</style>